import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, memo, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { DisabledTableServiceMenu } from 'shell/view-models/disabled-menu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface ServiceTableCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: DisabledTableServiceMenu;
}

const ServiceTableCollapseComponent = ({
  onSubItemClick,
  link,
  active,
}: ServiceTableCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  return (
    <Fragment>
      <ListItem
        button
        key="Tabelle di servizio"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Tabelle di servizio" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {active.ricercaImporto ? (
            <Link
              key={`${link}/ricerca-importo`}
              to={`${link}/ricerca-importo`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione Importo" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.tipoDoc ? (
            <Link key={`${link}/tipo-doc`} to={`${link}/tipo-doc`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Tipo Documento" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.modalitaRilascio ? (
            <Link
              key={`${link}/modalita-rilascio`}
              to={`${link}/modalita-rilascio`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Modalità Rilascio" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.ricercaRegistro ? (
            <Link
              key={`${link}/ricerca-registro`}
              to={`${link}/ricerca-registro`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gestione Registro" />
              </ListItem>
            </Link>
          ) : undefined}
        </List>
      </Collapse>
    </Fragment>
  );
};

ServiceTableCollapseComponent.displayName = 'Servive Table Collapse Item';

const ServiceTableCollapse = memo(ServiceTableCollapseComponent);

export default ServiceTableCollapse;
